import { ItemStone } from '../type'

export const createStoneDescription = (stone?: ItemStone): string => {
  if(!stone) return ''

  return [
    stone.name,
    stone.shape,
    `TW:${stone.totalWeight?.toFixed(2)}`,
    stone.certificateNumber,
    stone.color,
    stone.clarity,
  ]
    .filter(Boolean)
    .join(' / ')
}